import { Role } from './Columns'

interface Props {
  roleId: number
  roles: Role[]
}

const MainRoleCell = ({ roleId, roles }: Props) => {
  const role = roles.find((role: Role) => role.id === roleId)

  return <div>{role?.label || ''}</div>
}

export default MainRoleCell
